import { render, staticRenderFns } from "./CompleteTournament.vue?vue&type=template&id=420096e4&scoped=true"
import script from "./CompleteTournament.vue?vue&type=script&lang=js"
export * from "./CompleteTournament.vue?vue&type=script&lang=js"
import style0 from "./CompleteTournament.vue?vue&type=style&index=0&id=420096e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420096e4",
  null
  
)

export default component.exports